// actions.js
export const setPromoCode = (promoCode) => ({
    type: 'SET_PROMO_CODE',
    payload: promoCode,
});

export const setPromo = (promo) => ({
    type: 'SET_PROMO',
    payload: promo,
});


// actions.js
export const setCodeApplied = (codeApplied) => ({
    type: 'SET_PROMO_CODE_APPLIED',
    payload: codeApplied,
});

export const triggerGetBasket = () => ({
    type: 'PROMO_CODE_TRIGGER_GET_BASKET',
    payload: null,
});
